module.exports = {
      id: "share-mail-gnreach-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-3bd5c44086b3ee01fb1a36f6e1306c3d.svg#share-mail-gnreach",
      toString: function () {
        return this.url;
      }
    }